window.SwymBeforeRender = window.SwymBeforeRender || [];
window.SwymBeforeRender.push(function (UIObj) {
  UIObj.Registry.preloadComponent('productPrice', function (OriginalComp) {

    var FormatProductPriceComponent = /*#__PURE__*/function (_OriginalComp) {
      _inherits(FormatProductPriceComponent, _OriginalComp);
      var _super = _createSuper(FormatProductPriceComponent);

      function FormatProductPriceComponent() {
        _classCallCheck(this, FormatProductPriceComponent);
        return _super.apply(this, arguments);
      }

      _createClass(FormatProductPriceComponent, [{
        key: "render",
        value: function render() {
          var ctx = this.context.UI;
          var pr = this.props.listItem.pr;
          var originalPrice = this.props.productItem && this.props.productItem.op;

          // Safely get currency symbol
          var currency = (window._swat && window._swat.currency) ? window._swat.currency : 'R';

          ctx.FormatPrice = function (value) {
            // Strip any existing formatting, parse as float, round, convert to string (no commas)
            var numericValue = parseFloat(String(value).replace(/[^0-9.]/g, ''));
            if (isNaN(numericValue)) return currency + '0';
            return currency + Math.round(numericValue).toString();
          };

          return UIObj.Renderer.createElement("div", {
            "class": "swym-product-price swym-has-sale l"
          },
            UIObj.Renderer.createElement("div", {
              "class": "swym-product-final-price swym-value"
            }, ctx.FormatPrice(pr)),
            UIObj.Renderer.createElement("div", {
              "class": "swym-product-original-price swym-value"
            }, originalPrice ? ctx.FormatPrice(originalPrice) : "")
          );
        }
      }]);

      return FormatProductPriceComponent;
    }(OriginalComp);

    UIObj.Registry.register("WishlistContainer.Detail.Grid.Item.Price", FormatProductPriceComponent);
  });
});